{
  "OPTIONAL": "Незадължително",
  "BOOLEAN": {
    "YES": "Да",
    "NO": "Не"
  },
  "URGENCY": {
    "HIGH": "Високо",
    "LOW": "Ниско"
  },
  "APP": {
    "VERSION": "Това приложение работи с версия {version}"
  },
  "BUTTONS": {
    "NEXT": "Напред",
    "SKIP": "Прескачане",
    "CONFIRM": "Потвърждаване",
    "CLOSE": "Затваряне",
    "CANCEL": "Отказ",
    "SHOW_ALL": "Покажи всички",
    "HIDE": "Скрий"
  },
  "FOOTER": {
    "HOME": "Начало",
    "WORK": "Работа",
    "TOOLBOXES": "Инструменти",
    "PROFILE": "Профил"
  },
  "WORK": {
    "EMPTY_STATE_TITLE": "Все още няма проекти",
    "EMPTY_STATE_MESSAGE": "Проектите ще се появят скоро."
  },
  "HOME": {
    "PRODUCT_NAME": "i-LOP",
    "PRODUCT_NAME_BETA": "BETA",
    "CHECK_IN_STATUS": {
      "CHECKED_IN": "Регистриран",
      "CHECKED_OUT": "Излязъл",
      "CHECK_IN": "Регистрирай се",
      "CHECK_OUT": "Излез"
    },
    "TO_FULFILL": "За изпълнение",
    "CHECKLISTS": "Контролни списъци",
    "CERTIFICATES": "Сертификати",
    "SAFETY_INSTRUCTIONS": "Инструкции за безопасност",
    "TOOLBOXES": "Тулбокси",
    "NOT_ASSIGNED_TO_PROJECT": {
      "TITLE": "Няма активен проект",
      "MESSAGE": "Все още не сте регистрирани в проект. Намерете проект, за да започнете!",
      "BUTTON": "Намерете проект"
    },
    "ALERTS": "Съобщения",
    "NO_ALERTS": "В момента няма съобщения",
    "CURRENT_CHECK_IN": "В момента е регистриран",
    "LAST_PROJECT": "Последен проект",
    "CHECKED_IN_AT": "Регистриран в {time}",
    "LAST_CHECKED_IN": "Последно регистриран в {time}",
    "CHECKED_OUT_AT": "Излязъл в {time}",
    "FOREMAN": {
      "WORKERS_ON_SITE": "Работници на обекта",
      "START_WORK_INSTRUCTION": "Start Werk Instructie",
      "CREATE": "+ Създаване"
    }
  },
  "SAFETY_INSTRUCTIONS": {
    "TITLE": "Инструкции за безопасност",
    "ALL_COMPLETED": "Всички задължителни инструкции за безопасност са завършени"
  },
  "SAFETY_INSTRUCTION": {
    "PREVIOUS": "Предишна",
    "NEXT": "Напред",
    "FINISH": "Завърши",
    "QUESTION_HINT_AT_LEAST_ONE": "Моля, изберете поне един правилен отговор",
    "QUESTION_HINT_ALL_CORRECT": "Моля, изберете всички правилни отговори",
    "QUESTION_ERROR_ALL_CORRECT": "Това не са правилните отговори, моля опитайте отново",
    "QUESTION_CORRECT": "Правилен отговор!",
    "QUESTION_ERROR_UNANSWERED": "Моля, предоставете правилни отговори на всички въпроси, преди да продължите"
  },
  "LOGIN": {
    "EMAIL_LABEL": "Имейл",
    "PASSWORD_LABEL": "Парола",
    "EMAIL_PLACEHOLDER": "Въведете вашия имейл адрес",
    "PASSWORD_PLACEHOLDER": "Въведете вашата парола",
    "LOGIN_BUTTON": "Вход",
    "LOG_IN": "Вход",
    "FORGOT_PASSWORD": "Забравена парола?",
    "LOGIN_WITH_YIVI": "Вход с Yivi",
    "YIVI_HELP": "Използвайте Yivi, за да влезете или да създадете акаунт.",
    "PASSWORD_LOGIN": "Вход с парола"
  },
  "FORGOT_PASSWORD": {
    "TITLE": "Забравена парола",
    "DESCRIPTION": "Въведете вашия имейл адрес, за да ви изпратим имейл за възстановяване на паролата",
    "EMAIL_LABEL": "Имейл",
    "EMAIL_PLACEHOLDER": "Въведете вашия имейл адрес",
    "SUCCESS_MESSAGE_1": "Изпратихме потвърдителен имейл до",
    "SUCCESS_MESSAGE_2": "Проверете вашия имейл и кликнете върху линка за потвърждение, за да продължите",
    "SUBMIT_BUTTON": "Изпращане",
    "RESEND_BUTTON": "Изпрати имейла отново"
  },
  "RESET_PASSWORD": {
    "TITLE": "Нулиране на парола",
    "DESCRIPTION": "Създайте нова, силна парола, която не използвате за други уебсайтове",
    "PASSWORD_LABEL": "Нова парола",
    "PASSWORD_PLACEHOLDER": "Въведете вашата нова парола",
    "VERIFY_PASSWORD_LABEL": "Потвърдете новата парола",
    "VERIFY_PASSWORD_PLACEHOLDER": "Въведете новата парола отново",
    "PASSWORD_MISMATCH": "Паролите не съвпадат",
    "RESET_BUTTON": "Нулиране на парола",
    "INVALID_TOKEN": "Имейл адресът е невалиден или токенът е изтекъл. Моля, поискайте ново нулиране на паролата",
    "SUCCESS_TITLE": "Успех!",
    "SUCCESS_MESSAGE": "Вашата парола беше успешно нулирана. Сега можете да влезете с новата си парола.",
    "LOGIN": "Вход",
    "INVALID_LINK_TITLE": "Невалиден линк за нулиране",
    "INVALID_LINK_MESSAGE": "Този линк за нулиране на парола е невалиден или е изтекъл. Моля, поискайте ново нулиране на паролата.",
    "REQUEST_NEW_LINK": "Заявете нов линк за нулиране"
  },
  "ACCEPT_INVITATION": {
    "INTRO": {
      "TITLE": "Поканване",
      "DESCRIPTION": "Поканени сте за назначение. Прегледайте детайлите и приемете, за да започнете.",
      "SUBSCRIPT": "Този линк на поканата може да се използва само веднъж и изтича след 7 дни.",
      "BUTTON": "Приеми поканата"
    },
    "OFFER": {
      "ORGANISATION": "Организация",
      "FUNCTION": "Функция",
      "START_DATE": "Начална дата",
      "END_DATE": "Крайна дата",
      "INVITED_AS": "Поканен като"
    },
    "ACCEPT_ON_PHONE": {
      "TITLE": "Приемете от телефона си",
      "DESCRIPTION": "Сканирайте този код с камерата на телефона си, за да отворите тази покана в приложението i-LOP."
    },
    "SIGN_IN_TO_ACCEPT": "Влезте, за да приемете",
    "SUCCESS": {
      "TITLE": "Поканата е приета!",
      "DESCRIPTION": "Вашето назначение вече е свързано с вашия акаунт.",
      "BUTTON": "Продължи"
    },
    "ALREADY_ACCEPTED": {
      "TITLE": "Вече е приета",
      "DESCRIPTION": "Тази покана вече е приета."
    },
    "NOT_INVITABLE": {
      "TITLE": "Поканата вече не е валидна",
      "DESCRIPTION": "Тази заетост вече не е налична. Свържете се с вашия работодател."
    },
    "EXPIRED": {
      "TITLE": "Поканата е изтекла",
      "DESCRIPTION": "Този линк на поканата е изтекъл. Помолете вашия работодател да изпрати нова покана."
    },
    "INVALID_LINK": {
      "TITLE": "Невалиден линк на поканата",
      "DESCRIPTION": "Този линк на поканата е невалиден. Моля, свържете се с вашия администратор, за да поискате нова покана."
    }
  },
  "ERRORS": {
    "AUTHENTICATION": {
      "USER_ALREADY_EXISTS": "Имейл адресът вече се използва",
      "INVALID": "Вашият имейл адрес или парола са неправилни",
      "TRY_LATER": "В момента не можете да влезете, моля опитайте отново по-късно",
      "TOKEN_NOT_VALID": "Трябва да влезете отново",
      "YIVI_FAILED": "Възникна грешка при вход с Yivi"
    },
    "PROJECT_SELECT": {
      "ALREADY_ASSIGNED": "Вече сте назначени към този проект.",
      "NOT_ASSIGNED": "Не сте назначени към този проект."
    },
    "QRCODE_SCANNER": {
      "NO_PERMISSION": "Няма разрешение за използване на камерата",
      "INVALID": "QR кодът е невалиден",
      "EXPIRED": "QR кодът е изтекъл",
      "NO_PROJECT_SELECTED": "Първо изберете проекта, за който искате да проверите",
      "NO_PROJECT_TO_VERIFY": "Не ръководите нито един проект тук, така че няма проект, за който да проверите този работник",
      "PROJECTS_UNAVAILABLE": "Проектите ви не можаха да бъдат заредени. Проверете връзката си и сканирайте отново",
      "IDENTITY_NOT_RESOLVED": "QR кодът не съответства на един профил в приложението"
    },
    "AVATAR": {
      "TOO_LARGE": "Файлът със снимката е твърде голям. Изберете по-малка снимка.",
      "DIMENSIONS_TOO_LARGE": "Снимката е твърде голяма. Изберете по-малка снимка.",
      "UNSUPPORTED_IMAGE_TYPE": "Този тип файл не може да се използва като профилна снимка. Изберете изображение във формат JPEG, PNG или WebP.",
      "MALFORMED_IMAGE": "Снимката не можа да бъде прочетена. Опитайте с друга снимка.",
      "INVALID_IMAGE": "Снимката не може да се използва като профилна снимка."
    },
    "GENERIC": "Нещо се обърка",
    "NETWORK": "Не може да се свърже със сървъра",
    "NOT_FOUND": "Не може да се намери нещо",
    "UNKNOWN": "Възникна непозната грешка",
    "OFFLINE": "Не сте онлайн",
    "NOT_CHECKED_IN": "Не сте регистрирани в проект",
    "CONTENT_OUTSTANDING": "Завършете всички инструкции и toolbox-ове, преди да подпишете.",
    "INVALID_SIGNATURE": "Подписът не можа да бъде разчетен. Начертайте го отново.",
    "NO_PROJECT_ACCESS": "Нямате достъп до този проект",
    "NO_ACCESS": "Нямате права за това",
    "INVITATION_INVALID": "Линкът на поканата е невалиден.",
    "INVITATION_EXPIRED": "Линкът на поканата е изтекъл. Помолете вашия работодател да изпрати нов.",
    "EMPLOYMENT_ALREADY_ACCEPTED": "Това назначение вече е свързано с друг акаунт.",
    "EMPLOYMENT_NOT_INVITABLE": "Това назначение вече не може да бъде прието.",
    "PERSON_BINDING_CONFLICT": "Този запис на човек е свързан с друг акаунт в приложението. Свържете се с вашия администратор.",
    "GATE_ENTRY_REQUIRES_EXCEPTION": "Този работник не отговаря на изискванията, затова допускането трябва да се регистрира като изключение.",
    "PERSON_NOT_BOUND": "Това лице още няма профил в приложението.",
    "PERSON_NO_PROJECT_ACCESS": "Сканираното лице няма достъп до този проект",
    "PERSON_ALREADY_CHECKED_IN": "Сканираното лице вече е регистрирано в този проект",
    "SUBJECT_NOT_FOUND": "Акаунтът на сканираното лице не беше намерен",
    "SUBJECT_NOT_CHECKED_IN": "Този работник не е отчел влизане в този проект, така че не може да бъде допуснат тук"
  },
  "QRCODE_SCANNER": {
    "TITLE": "Сканиране",
    "SCAN_QR_CODE": "Сканирайте QR код",
    "RETRY_SCAN_QR_CODE": "Сканирайте QR код отново",
    "CAMERA_PERMISSION_DENIED_EXPLANATION": "Отворете настройките и дайте разрешение за използване на камерата",
    "OPEN_SETTINGS": "Отворете настройките",
    "SCAN_AGAIN": "Сканирайте следващия",
    "VERIFY_AGAINST": "Проверка за проект",
    "VERIFY_AGAINST_PLACEHOLDER": "Изберете проект"
  },
  "SELECT": {
    "DEFAULT_TITLE": "Изберете опция",
    "DEFAULT_MULTISELECT_TITLE": "Изберете една или повече опции"
  },
  "ONBOARDING": {
    "LOG_IN": "Вход",
    "WELCOME_MESSAGE": "Добре дошли в платформата за обучение и развитие."
  },
  "YIVI_REGISTRATION": {
    "TITLE": "Завършете вашия акаунт",
    "DESCRIPTION": "Получихме вашите идентификационни данни от Yivi. Попълнете останалата информация за iLOP, за да продължите.",
    "BIRTH_DATE": "Дата на раждане",
    "GENDER": "Пол",
    "SUBMIT": "Създайте акаунт",
    "CANCEL": "Отказ"
  },
  "GENDER": {
    "MALE": "Мъжки",
    "FEMALE": "Женски",
    "OTHER": "Друг"
  },
  "SAVED_WORK": {
    "BUTTON_TITLE": "Запазено"
  },
  "NOTIFICATION": {
    "DISMISS": "Затворете"
  },
  "PROFILE": {
    "PERSONAL_INFORMATION": "Лична информация",
    "NAME": "Име",
    "SURNAME": "Фамилия",
    "NICKNAME": "Предпочитано име",
    "NICKNAME_PLACEHOLDER": "Въведете предпочитаното от вас име (по избор)",
    "CERTIFICATES": "Сертификати",
    "SAVE": "Запазване",
    "SELECT_FUNCTION": "Изберете функция",
    "LOGOUT": "Изход",
    "TOAST": {
      "SAVED": "Личната информация е запазена",
      "ERROR": "Възникна грешка при запазването на личната информация"
    },
    "AVATAR": {
      "ACTION_SHEET_TITLE": "Какво искате да направите?",
      "CHANGE_LABEL": "Променете снимката на профила",
      "DELETE_LABEL": "Изтрийте снимката на профила",
      "CANCEL_LABEL": "Отказ",
      "RESIZE_ERROR": "Снимката не можа да бъде обработена. Опитайте с друга снимка.",
      "CROP_TITLE": "Изрежете снимката",
      "CROP_CONFIRM": "Използвайте снимката",
      "CROP_ZOOM_LABEL": "Увеличение"
    },
    "SETTINGS": "Настройки",
    "SETTINGS_ROUTES": {
      "CHANGE_PASSWORD": "Смяна на парола"
    },
    "PASSWORD": {
      "LABEL_CURRENT": "Текуща парола",
      "PLACEHOLDER_CURRENT": "Въведете вашата текуща парола",
      "LABEL_NEW": "Нова парола",
      "PLACEHOLDER_NEW": "Въведете вашата нова парола",
      "LABEL_VERIFY_NEW": "Потвърдете новата парола",
      "PLACEHOLDER_VERIFY_NEW": "Въведете новата парола отново",
      "BUTTON_LABEL": "Смяна на парола",
      "TOAST": {
        "SUCCESS": "Паролата е променена. Влезте отново с новата си парола",
        "ERROR": "Възникна грешка при смяната на паролата"
      },
      "FORM_VALIDATION_MISMATCH": "Новите пароли не съвпадат"
    }
  },
  "PROJECT_DETAILS": {
    "TITLE": "Детайли за проекта",
    "SWI_SIGNED": "SWI подписана",
    "SWI_OPEN": "SWI неподписана",
    "SWI_SIGNED_COUNT": "{count} подписани SWI",
    "SWI_SIGNED_OF": "{signed} от {total} подписани SWI",
    "REPORT_SAFETY_RISKS": "Докладвайте рискове за безопасност",
    "SEE_SAFETY_REPORTS": "Отворете доклади за безопасност",
    "CONTRACTOR": "Подизпълнител",
    "CLIENT": "Клиент",
    "SELECT": "Изберете",
    "WORKERS": "Работници",
    "DESELECT": "Отмяна на избора",
    "WORKERS_EMPTY_STATE": "Все още няма работници, регистрирани за този проект.",
    "UNKNOWN_EMPLOYER": "Неизвестен работодател",
    "CERTIFICATES": "Изискани сертификати за проекта",
    "TOOLBOXES": "Изискани toolboxes за проекта",
    "TOOLBOXES_ALL_COMPLETED": "Всички задължителни toolboxes са завършени",
    "ALERTS": "Съобщения",
    "CREATE_ALERT": "Добавете съобщение",
    "ALERTS_EMPTY_STATE": "В момента няма съобщения за този проект",
    "MAIN_OFFICE": "Централа",
    "CHECK_IN": "Регистриране",
    "CHECK_OUT": "Излизане",
    "AT_WORK": "{count} на работа",
    "REQUIREMENTS_CHECKLIST": "Изисквания за проекта",
    "OVERWRITE_CHECKIN_TITLE": "Регистриране",
    "OVERWRITE_CHECKIN_MESSAGE": "В момента сте регистрирани в \"{projectName}\". Ако се регистрирате тук, тази регистрация ще бъде прекратена.",
    "OVERWRITE_CHECKIN_CONFIRM": "Регистриране",
    "OVERWRITE_CHECKIN_CANCEL": "Отказ"
  },
  "PROJECT_SELECT": {
    "TITLE": "Изберете проект",
    "PROJECT_NAME": "Име на проекта",
    "PROJECT_FUNCTION": "Функция в проекта",
    "SELECT_AT_LEAST_ONE_FUNCTION": "Изберете поне една функция.",
    "EMPLOYEE": "Служител",
    "NEXT": "Напред",
    "ALREADY_CHECKED_IN_TITLE": "Вече сте регистрирани",
    "ALREADY_CHECKED_IN_MESSAGE": "Вече сте регистрирани в този проект. Не е необходимо да правите нищо.",
    "INVALID_CODE": "Този код на проекта вече не е валиден. Поискайте текущия код от ръководителя на обекта.",
    "REPORT_TO_FOREMAN_TITLE": "Явете се при ръководителя на обекта",
    "REPORT_TO_FOREMAN_MESSAGE": "Регистрирани сте, но не сте включени в списъка на този проект. Явете се веднага при ръководителя на обекта."
  },
  "PROJECT_SELECT_CONFIRM": {
    "ALL_FULFILLED": "Всички изисквания са изпълнени",
    "BUTTON": "Потвърдете",
    "TITLE": "Потвърдете избора на проект"
  },
  "PROJECT_SELECT_SUCCESS": {
    "SUCCESS": "Успех!",
    "SELECTED": "Регистрирахте се за проекта.",
    "DESELECTED": "Отписахте се от проекта.",
    "BUTTON": "Начало"
  },
  "CERTIFICATE": {
    "EXPIRED": "Изтекъл на {date}",
    "VALID_UNTIL": "Валиден до {date}",
    "EXPIRES_IN": "Изтича след {duration}",
    "EXPIRES_SOON": "Изтича в рамките на 3 месеца",
    "EXPIRES_NEVER": "Никога не изтича",
    "MISSING": "Все още не е получен",
    "PENDING": "Изчаква преглед",
    "REJECTED": "Отхвърлено",
    "VIEW_DOCUMENT": "Документ",
    "VIEW_DOCUMENT_N": "Документ {n}",
    "REGISTERED_TO": "Регистрирано на името на {name}"
  },
  "DOCUMENT_INPUT": {
    "ADD": "Добавяне на снимка или PDF",
    "TAKE_PHOTO": "Направете снимка",
    "CHOOSE_FROM_LIBRARY": "Изберете от библиотеката",
    "CHOOSE_PDF": "Изберете PDF",
    "REMOVE": "Премахване",
    "CANCEL": "Отказ"
  },
  "ADD_CERTIFICATE": {
    "TITLE": "Добавяне на сертификат",
    "CERTIFICATE": "Сертификат",
    "CERTIFICATE_NUMBER": "Номер на сертификат",
    "ISSUED_ON": "Издаден на",
    "EXPIRES_ON": "Изтича на",
    "DOCUMENT": "Документ",
    "MISSING_FIELDS": "Моля, изберете организация и сертификат.",
    "ERROR": "Нещо се обърка. Моля, опитайте отново.",
    "CHOOSER": {
      "IMPORT": "Импортиране от регистър",
      "UPLOAD": "Качване на документ"
    }
  },
  "IMPORT_CERTIFICATE": {
    "TITLE": "Импортиране на сертификат",
    "LAST_NAME": "Фамилия",
    "DATE_OF_BIRTH": "Дата на раждане",
    "REGISTRY": "Регистър",
    "CERTIFICATE_NUMBER": "Номер на сертификат",
    "MISSING_FIELDS": "Моля, попълнете всички полета.",
    "SUCCESS": "Сертификатът е импортиран.",
    "STATUS": {
      "NOTFOUND": "Не е намерен сертификат за тези данни.",
      "REGISTRYERROR": "Регистърът не можа да бъде достигнат в момента. Моля, опитайте отново по-късно."
    }
  },
  "CERTIFICATES": {
    "NO_CERTIFICATES": "Не са намерени сертификати",
    "EXPIRED_CERTIFICATES": "Някои от вашите сертификати са изтекли. Подновете ги, за да продължите да работите."
  },
  "MARKDOWN_CONTENT": {
    "TERMS_AND_CONDITIONS": "Общи условия",
    "PRIVACY_POLICY": "Политика за поверителност",
    "APP_INFO": "Информация за приложението",
    "AVG_STATEMENT": "Декларация за GDPR"
  },
  "HUMANIZE_DURATION": {
    "MONTHS": "{count, plural, =1{месец} other{месеца}}",
    "DAYS": "{count, plural, =1{ден} other{дни}}",
    "SOON": "скоро"
  },
  "PERSON": {
    "FIRST_NAME": "Собствено име",
    "LAST_NAME": "Фамилия",
    "EMAIL": "Имейл адрес",
    "FUNCTION": "Функция"
  },
  "WORKER_PROFILE": {
    "FUNCTION": "Функция",
    "PROJECT": "Текущ проект",
    "CERTIFICATES": "Сертификати",
    "PROJECT_DETAILS": "Детайли за проекта",
    "UPDATE_PERSON_ACTION": "Редактиране на детайли",
    "ASSIGN_TO_PROJECT_ACTION": "Назначете към моя проект"
  },
  "PHOTOS": {
    "PROFILE_PHOTO": "Изберете снимка за профил",
    "CANCEL": "Отмяна",
    "TAKE_PHOTO": "Направете снимка",
    "CHOOSE_FROM_LIBRARY": "Изберете от галерията"
  },
  "UMA": {
    "MY_REPORTS": {
      "TITLE": "Моите доклади",
      "EMPTY_STATE_TITLE": "Няма доклади",
      "EMPTY_STATE_MESSAGE": "Рисковете за безопасност, които сте докладвали самостоятелно, ще се появят тук.",
      "CREATE_REPORT": "Създайте доклад"
    },
    "REPORT": {
      "ASSIGNED_TO": "Обработва се от {name}",
      "REPORTED_BY": "Докладвано от {name}",
      "REPORTED_BY_ANONYMOUS": "Докладвано анонимно"
    },
    "PROJECT_REPORTS": {
      "TITLE": "Доклади за {projectName}",
      "EMPTY_STATE_TITLE": "Няма доклади",
      "EMPTY_STATE_MESSAGE": "Рисковете за безопасност, докладвани в този проект, ще се появят тук."
    },
    "CANNOT_CREATE_REPORT": {
      "TITLE": "Не може да се създаде доклад",
      "DESCRIPTION": "Не сте регистрирани в проект. Регистрирайте се, за да можете да създадете доклад."
    },
    "NEW_REPORT": {
      "CREATE_NEW_REPORT": "Създайте доклад",
      "GENERAL": {
        "FORM_TITLE": "Общи",
        "CATEGORY": "Какво искате да докладвате?",
        "IS_SOLVED": "Решено ли е?",
        "IS_URGENT": "Спешност",
        "IS_ANONYMOUS": "Докладвайте анонимно",
        "PROJECT": "В кой проект искате да направите този доклад?",
        "NO_PROJECTS": "Не сте регистрирани в проект. Регистрирайте се, за да можете да създадете доклад.",
        "CHOOSE_PROJECT": "Изберете проект",
        "CONFIRM_PROJECT": "Не сте регистрирани в този проект. Сигурни ли сте, че искате да направите този доклад?",
        "CONFIRM_PROJECT_BUTTON": "Да, сигурен съм",
        "VICTIMS": "Има ли пострадали?",
        "ABSENTEEISM": "Отсъствие",
        "HOSPITALISED": "Хоспитализирани ли са?",
        "HOSPITALISED_WARNING": {
          "BEFORE_PHONE": "В СЛУЧАЙ НА СЕРИОЗЕН ИНЦИДЕНТ ИЛИ НАРАНЯВАНЕ, ИЗИСКВАЩО ХОСПИТАЛИЗАЦИЯ, ВИНАГИ ПЪРВО СЕ ОБАДЕТЕ НА СПЕШНИТЕ СЛУЖБИ",
          "BETWEEN_PHONE_AND_URL": "ИЛИ ЧРЕЗ ОНЛАЙН ФОРМУЛЯРА:",
          "AFTER_LINK": "Консултирайте се с вашия ръководител, бригадир или координатор по безопасност и здраве, който отговаря за този доклад."
        }
      },
      "SITUATION": {
        "FORM_TITLE": "Ситуация",
        "PHOTOS": "Как изглежда ситуацията?",
        "PHOTOS_PLACEHOLDER": "Добавете една или повече снимки или попълнете описание",
        "DESCRIPTION": "Опишете ситуацията",
        "SAFE_SITUATION_DESCRIPTION": "Безопасна ситуация",
        "RISK": "Риск",
        "DESCRIPTION_OF_SITUATION": "Описание на ситуацията",
        "ACTIONS_TAKEN": "Предприети действия",
        "RISK_CATEGORY": {
          "LABEL": "Категория риск",
          "PLACEHOLDER": "Изберете категория",
          "REQUIRED": "Категорията е задължителна"
        }
      },
      "SUMMARY": {
        "TITLE": "Докладът е изпратен",
        "MESSAGE": "Доклад с номер #{{id}} е изпратен."
      },
      "SEND": "Изпратете",
      "SUCCESS_TOAST": "Докладът за безопасност е създаден успешно",
      "VALIDATION": {
        "MISSING_FIELDS": "Моля, попълнете всички задължителни полета"
      }
    },
    "REPORT_DETAILS": {
      "NOT_ASSIGNED_TO": "Не е назначен на служител",
      "ASSIGNED_TO_PERSON": "Назначен на служител",
      "ASSIGN_TO_PERSON_PLACEHOLDER": "Назначете на служител",
      "DETAILS": "Детайли",
      "TITLE": "Преглед на доклад {reportId}",
      "PROJECT_NAME": "Проект",
      "REPORTER": "Докладчик",
      "ANONYMOUS_REPORTER": "Анонимен докладчик",
      "UNKNOWN_AUTHOR": "Неизвестен автор",
      "CATEGORY": "Тип доклад",
      "URGENCY": "Спешност",
      "SOLVED": "Решен",
      "PHOTOS": "Снимки",
      "PHOTOS_EMPTY": "Този доклад не съдържа снимки",
      "DESCRIPTION": "Описание",
      "RISK": "Риск",
      "CREATED_AT": "Създаден на",
      "CREATE_COMMENT": "Публикувайте коментар",
      "COMMENTS": "Коментари",
      "COMMENTS_EMPTY": "Все още не са публикувани коментари",
      "COMMENT_BY": "Коментар от {person}",
      "COMMENT_CREATED": "Коментарът е публикуван успешно",
      "LOGS": "Дневници",
      "LOGS_EMPTY": "Все още няма дневници",
      "LOG": {
        "CREATED": "Докладът е създаден от {actor}",
        "STATUS_CHANGED": "Статусът е променен на {newStatus} от {actor}",
        "COMMENTED": "Коментар е публикуван от {actor}"
      },
      "NOT_IN_PROJECT": "Докладчикът не беше регистриран в този проект"
    }
  },
  "PUSH_NOTIFICATIONS": {
    "CLOSE": "Затворете",
    "OPEN": "Отворете"
  },
  "REPORT_CATEGORY": {
    "ACCIDENT": "Инцидент",
    "UNSAFE_SITUATION": "Небезопасно",
    "SAFE_SITUATION": "Безопасно"
  },
  "REPORT_STATUS": {
    "NEW": "Непрочетен",
    "IN_PROGRESS": "В процес",
    "SOLVED": "Решен",
    "ON_HOLD": "Паузиран"
  },
  "NOTIFICATIONS": {
    "TITLE": "Известия",
    "EMPTY_STATE_TITLE": "Няма известия",
    "EMPTY_STATE_MESSAGE": "Тук ще намерите всички важни известия от настоящето и миналото",
    "NOTIFICATION_SENT_AT_FORMAT": "d MMMM HH:mm",
    "MARK_AS_READ": "Маркирай като прочетено",
    "MARK_ALL_AS_READ": "Маркирай всички като прочетени",
    "MARK_ALL_AS_READ_SUCCESS": "Всички известия са маркирани като прочетени",
    "DELETE": "Изтрий",
    "DELETE_SUCCESS": "Известието е изтрито"
  },
  "REPORT_TRANSITION": {
    "NEW": "Обратно към ново",
    "IN_PROGRESS": "Приемете в процес",
    "SOLVED": "Маркирайте като решен",
    "ON_HOLD": "Паузиране",
    "SOLVED_CONFIRMATION_TITLE": "Маркирайте доклада като решен?",
    "SOLVED_CONFIRMATION_MESSAGE": "Сигурни ли сте, че искате да маркирате този доклад като решен?"
  },
  "SPEECH_RECOGNITION": {
    "TITLE": "Кажете текста си",
    "BTN_LABEL": "Кажете текст",
    "PERMISSION_ERROR": "Не може да се каже текст. Не е дадено разрешение. Отворете настройките на телефона си и дайте разрешение да кажете текст за това приложение.",
    "LISTENING": "Слушам...",
    "USE_RESULT": "Въведете резултата"
  },
  "CERTIFICATE_LIST": {
    "MY_EMPTY_STATE": "Все още не сте получили сертификати",
    "PERSON_EMPTY_STATE": "Този служител все още не е получил сертификати",
    "PROJECT_EMPTY_STATE": "Няма подходящи сертификати за този проект",
    "PERSON_PROJECT_EMPTY_STATE": "Няма подходящи сертификати за този служител в този проект"
  },
  "ALERT_CATEGORY": {
    "GENERAL": "Общи",
    "WEATHER": "Време",
    "LOGISTIC": "Логистика",
    "SAFETY": "Безопасност"
  },
  "ALERT_DETAILS": {
    "EDIT": "Редактиране",
    "TITLE": "Детайли за съобщението",
    "CONFIRM": "Разбрано",
    "DELETE_TITLE": "Изтрий съобщението",
    "DELETE_MESSAGE": "Сигурни ли сте, че искате да изтриете това съобщение?",
    "DELETE_CONFIRM": "Изтрий",
    "DELETE_SUCCESS": "Съобщението е изтрито"
  },
  "ALERT_PLAYER": {
    "PLAY": "Възпроизвеждане",
    "PAUSE": "Пауза",
    "LANGUAGE": "Език",
    "SEEK": "Напредък",
    "FULLSCREEN": "Цял екран"
  },
  "ALERT": {
    "CATEGORY": "Категория",
    "TITLE": "Заглавие",
    "DESCRIPTION": "Описание",
    "VALID_FROM": "От",
    "VALID_UNTIL": "До",
    "FROM": "от",
    "UNTIL": "до",
    "VIDEO": "Видео",
    "REMOVE_VIDEO": "Премахнете видеото",
    "TYPE": "Тип съобщение",
    "TYPE_TEXT": "Текст",
    "TYPE_VIDEO": "Видео",
    "ADD_TARGET_AUDIENCE": "Добавете целева аудитория",
    "TARGET_AUDIENCE": "Целева аудитория",
    "TARGET_AUDIENCE_EVERYONE": "Всички",
    "TARGET_AUDIENCE_MANAGEMENT": "Ръководство",
    "SELECT_TARGET_AUDIENCE": "Изберете целева аудитория",
    "NO_FILE_SELECTED": "Няма избран файл",
    "CHOOSE_FILE": "Изберете файл",
    "TRANSLATION": "Превод",
    "TRANSLATION_DESCRIPTION": "Преведете това видео",
    "VIDEO_UPLOAD_FAILED": "Качването на видеото се провали",
    "AUDIENCE": {
      "MANAGEMENT": "Ръководство",
      "ORGANISATION": "Организация:",
      "FUNCTION": "Функция:",
      "FUNCTION_GROUP": "Група функции:",
      "ADD_MANAGEMENT": "Ръководство",
      "ADD_ORGANISATION": "Организация",
      "ADD_FUNCTION": "Функция или група",
      "SELECT_ORGANISATION": "Изберете организация",
      "NO_ORGANISATIONS": "Няма организации по този проект.",
      "LOADING_ORGANISATIONS": "Зарежда се..."
    }
  },
  "NEW_ALERT": {
    "TITLE": "Добавете съобщение",
    "ACTION": "Създайте съобщение",
    "SUCCESS_TOAST_MESSAGE": "Съобщението е създадено успешно"
  },
  "EDIT_ALERT": {
    "TITLE": "Редактирайте съобщението",
    "ACTION": "Запазете промените",
    "SUCCESS_TOAST_MESSAGE": "Съобщението е актуализирано успешно"
  },
  "EDIT_PERSON_PROJECT": {
    "TITLE": "Назначете проект",
    "SUCCESS_TOAST_MESSAGE": "Назначаването на проект е актуализирано успешно"
  },
  "REASSIGN_PERSON_PROJECT": {
    "TITLE": "Назначете проект",
    "SUCCESS_TOAST_MESSAGE": "Назначаването на проект е успешно"
  },
  "SELECT_UI": {
    "SEARCHBAR_PLACEHOLDER": "Търсене на опция"
  },
  "CHECKLIST": {
    "COMPLETED": "Контролният списък е завършен успешно",
    "ERROR": "Нещо се обърка при завършването на контролния списък",
    "LIST_LABEL": "Контролни списъци",
    "ALL_COMPLETED": "Всички задължителни контролни списъци са завършени",
    "COMPLETE": "Завършете"
  },
  "PASSWORD_COMPLEXITY": {
    "REQUIREMENTS": "Изисквания за паролата:",
    "MIN_LENGTH": "Поне {minLength} знака",
    "UPPERCASE": "Поне една главна буква",
    "LOWERCASE": "Поне една малка буква",
    "DIGIT": "Поне една цифра",
    "SPECIAL_CHAR": "Поне един специален знак"
  },
  "FUNCTION_SELECT": {
    "ROOT": "Основен",
    "SEARCH_PLACEHOLDER": "Търсене на функция",
    "NO_RESULTS": "Няма намерени функции",
    "WHOLE_CATEGORY": "Цялата група: {name}"
  },
  "WORKER_DETAIL": {
    "START_WORK_INSTRUCTION": "Start Werk Instructie",
    "SWI_SIGNED_ON": "Подписана на {moment}",
    "NO_SWI_SIGNATURE": "Още не е подписана",
    "SWI_SIGNATURE_ALT": "Подпис",
    "SWI_SIGNATURE_FAILED": "Подписът не можа да бъде зареден",
    "TITLE": "Данни за работника",
    "ITEM_STATUS": {
      "PRESENT": "Налично",
      "MISSING": "Липсва",
      "EXPIRED": "Изтекло",
      "EXPIRED_GRACE_PERIOD": "Изтекло (гратисен период)"
    },
    "CERTIFICATES": "Сертификати",
    "CHECKLISTS": "Контролни списъци",
    "SAFETY_INSTRUCTIONS": "Инструкции за безопасност",
    "TOOLBOXES": "Инструментални комплекти",
    "NAME": "Име",
    "VERIFIED_AGAINST": "Проверено за {project}",
    "BASIC_INFORMATION": "Основна информация",
    "ILOP_CONTENT": "i-LOP съдържание",
    "NO_EMPLOYMENTS": "Този работник няма активни трудови правоотношения",
    "NO_ILOP_CONTENT": "Няма релевантно i-LOP съдържание за този работник в този проект",
    "CHECK_IN": {
      "SINCE": "Регистриран в"
    },
    "EMPLOYMENT": {
      "FUNCTION": "Функция",
      "FROM": "От",
      "TO": "До"
    },
    "CERTIFICATE": {
      "NUMBER": "Номер",
      "ISSUED_ON": "Издаден на",
      "ISSUED_FOR": "Издаден на име",
      "EXPIRES_ON": "Изтича на"
    },
    "CONTENT": {
      "COMPLETED_ON": "Завършено на",
      "MEETING_ENDED": "Срещата приключи",
      "SIGNED": "Подписано"
    },
    "KVK": {
      "NUMBER": "Номер в KvK",
      "DOCUMENT_DATE": "Извлечение от дата",
      "VALID_UNTIL": "Валидно до",
      "DOCUMENT": "Извлечение от KvK"
    },
    "OPEN_DOCUMENT": "Отваряне",
    "OPEN_DOCUMENT_FAILED": "Документът не можа да бъде отворен"
  },
  "GATE_ENTRY": {
    "TITLE": "Регистриране на достъп",
    "GAPS_HINT": "Този работник не отговаря на изискванията, затова допускането му е изключение.",
    "NOT_CHECKED_IN_HINT": "Този работник не е отчел влизане в този проект. Отчетете влизането му, за да го допуснете, или откажете достъп.",
    "CHECK_IN_WORKER": "Отчети влизане на работника",
    "DECISION": {
      "VALID": "Валиден",
      "EXCEPTION": "Изключение",
      "DENIED": "Отказан"
    },
    "REASON": {
      "HEADER_EXCEPTION": "Причина за изключението",
      "HEADER_DENIED": "Причина за отказа",
      "MESSAGE": "Това се записва с вашето име и часа.",
      "PLACEHOLDER": "Опишете причината",
      "CONFIRM": "Регистрирай"
    },
    "REGISTERED": "Достъпът е регистриран"
  },
  "EMPLOYMENT": {
    "TIMELINE": {
      "TITLE": "Трудова история",
      "NO_EMPLOYMENTS": "Няма налична трудова история.",
      "PRESENT": "Настояще",
      "ACTIVE": "Активен",
      "NOT_YET_ACTIVE": "Още не е активен",
      "LOAD_ERROR": "Възникна грешка при зареждането на трудовата история.",
      "STATUS_FOR_ADMIN_REVIEW": "В преглед",
      "STATUS_FOR_USER_REVIEW": "Проверете вашата трудова заетост",
      "ADD_EMPLOYMENT": "Добави",
      "REVIEW_NOTICE": "Има трудови заетости, които очакват вашия преглед.",
      "REVIEW_NOTICE_ACTION": "Докоснете, за да ги прегледате и оцените.",
      "REVIEW_OPEN": "Прегледай",
      "REVIEW_DETAILS_TITLE": "Преглед на трудова заетост",
      "FUNCTION": "Функция",
      "START_DATE": "Начална дата",
      "END_DATE": "Крайна дата",
      "MANAGERIAL": "Ръководна функция",
      "YES": "Да",
      "NO": "Не",
      "ACCEPT": "Приемам",
      "REJECT": "Отказвам",
      "REVIEW_ACCEPT_SUCCESS": "Трудовата заетост е приета успешно.",
      "REVIEW_REJECT_SUCCESS": "Трудовата заетост е отказана успешно.",
      "REVIEW_ERROR": "Възникна грешка при прегледа на трудовата заетост."
    },
    "DETAIL": {
      "TITLE": "Заетост",
      "NOT_FOUND": "Тази заетост не можа да бъде намерена."
    },
    "CREATE": {
      "TITLE": "Добавете трудова заетост",
      "ORGANISATION": "Организация",
      "SEARCH_ORGANISATION": "Търсене на организация",
      "NO_ORGANISATIONS": "Не са намерени организации.",
      "FUNCTION": "Функция",
      "START_DATE": "Начална дата",
      "END_DATE": "Крайна дата",
      "MANAGERIAL_LABEL": "Ръководна функция",
      "BUSINESS_REGISTRY_NUMBER": "Регистрационен номер на фирмата",
      "SAVE": "Запази",
      "SAVE_SUCCESS": "Трудовата заетост е добавена успешно.",
      "SAVE_ERROR": "Възникна грешка при добавянето на трудовата заетост.",
      "LOAD_ORGANISATIONS_ERROR": "Възникна грешка при зареждането на организациите.",
      "END_DATE_BEFORE_START": "Крайната дата не може да бъде преди началната дата.",
      "ORGANISATION_UNAVAILABLE": "Този работодател вече не е наличен. Изберете друг.",
      "FUNCTION_UNKNOWN": "Тази функция вече не е налична. Изберете друга.",
      "BINDING_CONFLICT": "Този работодател вече познава някой с вашия имейл адрес, под друг акаунт. Помолете ги вместо това да ви поканят.",
      "IDENTITY_INCOMPLETE": "В акаунта ви липсва вашето име или имейл адрес, поради което работодател все още не може да ви регистрира. Влезте с Yivi, за да го попълните.",
      "REQUEST_ALREADY_PENDING": "Вече имате чакаща заявка при този работодател. Изчакайте техния отговор.",
      "INVITATION_PENDING": "Този работодател вече ви е поканил. Приемете или откажете тази покана в трудовата си история."
    }
  },
  "TOOLBOXES": {
    "TABS": {
      "LIST": "Списък",
      "REGISTRATION": "Регистрация"
    },
    "EMPTY_STATE": "Няма налични toolboxes",
    "LAST_UPDATED": "Последна актуализация",
    "VIEW_DOCUMENT": "Преглед на документ",
    "ASYNC": {
      "COMPLETED": "Toolbox завършен",
      "ERROR_COMPLETING": "Неуспешно завършване на toolbox"
    },
    "FOLLOWED": {
      "TITLE": "Завършени toolboxes",
      "LINK": "Вижте завършените toolboxes",
      "FILTER_CATEGORY": "Категория",
      "FILTER_TYPE": "Вид",
      "TYPE_SYNCHRONOUS": "Синхронен",
      "TYPE_ASYNCHRONOUS": "Асинхронен",
      "TYPE_MANUAL": "Ръчен",
      "NOT_AVAILABLE": "Вече не е достъпен",
      "EMPTY_STATE": "Все още не сте завършили нито един toolbox",
      "EMPTY_FILTERED": "Няма завършени toolboxes, отговарящи на тези филтри"
    },
    "MEETING": {
      "HOST_MEETING": "Организирай toolbox среща",
      "START_ANOTHER_TITLE": "Да започна ли още една среща?",
      "START_ANOTHER_MESSAGE": "Вече имате {count, plural, =1{една toolbox среща} other{# toolbox срещи}} в ход. Да започна ли още една?",
      "START_ANOTHER_CONFIRM": "Започни още една",
      "ONLY_MANAGERIAL_CAN_HOST": "Само мениджъри могат да организират toolbox среща",
      "ONLY_MANAGERIAL_CAN_MANAGE": "Само мениджъри могат да управляват toolbox среща",
      "VIEW_ACTIVE_MEETING": "Виж активната среща",
      "SELECT_ACTIVE_MEETING": "Изберете среща",
      "MANUAL": {
        "START_BUTTON": "Стартиране на ръчна среща",
        "DESCRIPTION": "Стартирайте нова ръчна среща на toolbox за вашия екип като мениджър.",
        "START_TITLE": "Стартиране на ръчна среща",
        "ORGANISATION": "Организация",
        "ORGANISATION_PLACEHOLDER": "Изберете организация",
        "TITLE": "Заглавие",
        "TITLE_PLACEHOLDER": "Въведете заглавие",
        "DESCRIPTION_PLACEHOLDER": "Незадължително описание",
        "START_MISSING_FIELDS": "Моля, попълнете всички задължителни полета",
        "TITLE_REQUIRED": "Заглавието е задължително",
        "TITLE_NOT_ALLOWED": "Заглавието може да се променя само за ръчни срещи",
        "END_BEFORE_START": "Крайният час не може да бъде преди началния",
        "ACTIVE_LIST_TITLE": "Вашите toolbox срещи",
        "ACTIVE_BADGE": "В ход",
        "PLANNED_BADGE": "Планирана",
        "CONTINUE_BUTTON": "Продължи с тази среща"
      },
      "TITLE": "Toolbox среща",
      "PARTICIPANTS": "Участници",
      "NO_PARTICIPANTS": "Още няма участници",
      "EXTERNAL_PARTICIPANT": "външен",
      "INFORMATION": "Информация",
      "START_DATE": "Начална дата",
      "END_DATE": "Крайна дата",
      "DESCRIPTION": "Описание",
      "FINISH_MEETING": "Приключи срещата",
      "EDIT_MEETING": "Редактирай срещата",
      "SAVE": "Запази",
      "CANCEL": "Отказ",
      "FINISH_CONFIRMATION_TITLE": "Приключване на срещата?",
      "FINISH_CONFIRMATION_MESSAGE": "Сигурни ли сте, че искате да приключите тази toolbox среща?",
      "MEETING_ENDED_TITLE": "Срещата приключи",
      "MEETING_ENDED_MESSAGE": "Тази среща беше приключена на {endTime} от {finishedByName}",
      "MEETING_ALREADY_STARTED": "Срещата вече е започната от друг човек",
      "ERROR_POLLING_MEETING": "Възникна грешка при проверка за срещи",
      "ERROR_STARTING_MEETING": "Неуспешно стартиране на срещата",
      "ERROR_LOADING_MEETING": "Неуспешно зареждане на срещата",
      "ERROR_UPDATING_MEETING": "Неуспешно обновяване на срещата",
      "ERROR_FINISHING_MEETING": "Неуспешно приключване на срещата",
      "ERROR_END_BEFORE_START": "Крайният час не може да е преди началния час",
      "SCAN_QR_CODE": "Сканирай QR код",
      "RETRY_SCAN": "Опитай отново",
      "SCAN_TO_JOIN": "Сканирай, за да се присъединиш",
      "JOIN_TOOLBOX_MEETING": "Присъедини се към среща на toolbox",
      "JOIN_DESCRIPTION": "Присъединете се към съществуваща среща на toolbox, като сканирате QR код или въведете код за среща.",
      "QR_SCAN_WRONG_MEETING": "Този QR код е за различна среща",
      "QR_SCAN_ALREADY_PARTICIPANT": "Вече сте участник в тази среща",
      "QR_SCAN_INVALID": "Невалиден формат на QR код",
      "QR_SCAN_ERROR": "Възникна грешка при сканиране",
      "QR_SCAN_NO_PERMISSION": "Необходимо е разрешение за камера, за да сканирате QR кодове",
      "SUCCESSFULLY_JOINED": "Успешно се присъединихте към срещата",
      "ADD_PARTICIPANT": {
        "TITLE": "Добави участник",
        "CHOOSE_METHOD": "Изберете как искате да добавите участник към тази toolbox среща: сканирайте техния i-LOP QR код или въведете ръчно име",
        "SCAN_QR_CODE": "Сканирай QR код",
        "MANUAL": "Ръчно",
        "MANUAL_ENTRY": "Ръчно въвеждане",
        "OR": "или",
        "FIRST_NAME": "Собствено име",
        "LAST_NAME": "Фамилия",
        "FIRST_NAME_PLACEHOLDER": "Въведете собствено име",
        "LAST_NAME_PLACEHOLDER": "Въведете фамилия",
        "CONFIRM": "Потвърди",
        "ADDING": "Добавяне...",
        "SUCCESS": "Участникът е добавен успешно",
        "ERROR": "Неуспешно добавяне на участник",
        "MEETING_NOT_FOUND": "Срещата не е намерена",
        "ALREADY_PARTICIPANT": "Този човек вече е участник в срещата",
        "MEETING_INACTIVE": "Срещата не е активна",
        "QR_VERIFY_PERMISSION_ERROR": "Нямате разрешение да проверите този QR код. Използвайте ръчно въвеждане вместо това.",
        "MISSING_PARAMETERS": "Липсват задължителни параметри за навигация",
        "NAVIGATION_ERROR": "Неуспешна навигация към страницата за добавяне на участник",
        "PERSON_NOT_IN_ORGANISATION": "Сканираният човек не принадлежи към вашата организация",
        "PERSON_NOT_BOUND": "Този човек все още няма акаунт в приложението. Добавете го като външен участник.",
        "PERSON_BINDING_CONFLICT": "Този човек е свързан с няколко акаунта в приложението и не може да бъде добавен. Свържете се с вашия администратор.",
        "NO_PERSON_RECORD": "Този работник има акаунт, но все още не е служител на организация, затова не може да бъде добавен като участник. Добавете го като външен участник."
      }
    }
  },
  "SIGNATURE": {
    "TITLE": "Подпис",
    "INSTRUCTIONS": "Моля, подпишете по-долу",
    "CLEAR": "Изчисти",
    "CONFIRM": "Потвърди"
  },
  "PERSON_CHECKIN_CARD": {
    "CHECKED_IN_AT": "Регистриран в:",
    "LAST_CHECKED_OUT_AT": "Последно излязъл в:",
    "NOT_CHECKED_IN": "Не е регистриран",
    "CERTIFICATES": "Сертификати",
    "MORE_CERTIFICATES": "{count} още",
    "ADD_CERTIFICATE": "Добави сертификат"
  },
  "ZZP_COMPANY": {
    "TITLE": "Фирмен профил (ZZP)",
    "INTRO": "Създайте профил за вашата фирма с един служител (ZZP).",
    "COMPANY_NAME": "Име на фирмата",
    "KVK_NUMBER": "Номер в Търговската камара (KvK)",
    "SAVE": "Запазване",
    "TOAST": {
      "SAVED": "Фирменият профил е запазен",
      "ERROR": "Възникна грешка при запазването на фирмения профил",
      "LOAD_ERROR": "Възникна грешка при зареждането на фирмения профил"
    },
    "KVK_EXTRACT": {
      "LABEL": "Извлечение от KvK",
      "ADD": "Добавяне на извлечение от KvK",
      "VIEW": "Преглед на извлечението от KvK",
      "REMOVE": "Премахване",
      "UPLOADED": "Извлечението от KvK е качено",
      "REMOVED": "Извлечението от KvK е премахнато",
      "INVALID_TYPE": "Разрешени са само PDF или файлове с изображения",
      "DOCUMENT_DATE": "Дата върху извлечението от KvK",
      "VALID_UNTIL": "Валидно до",
      "OUT_OF_DATE": "Това извлечение от KvK е прекалено старо. Качете по-ново.",
      "NEEDS_DATE": "Въведете датата от извлечението, за да бъде зачетено.",
      "NEEDS_DOCUMENT": "Качете извлечението от KvK, за да бъде зачетена датата."
    }
  },
  "START_WORK_INSTRUCTION": {
    "NEW_TITLE": "Нова SWI",
    "STEP_OF": "Стъпка {step} от {total}",
    "NEXT": "Напред",
    "LOADING": "Зареждане…",
    "SAVED": "Start Werk Instructie е запазена",
    "STEP_LABEL": {
      "PERIOD": "Дата или период",
      "MESSAGES": "Съобщения: днешните инструкции за безопасност",
      "INSTRUCTIONS": "Инструкции",
      "TOOLBOXES": "Toolbox-и",
      "CHECKLISTS": "Контролни списъци",
      "SUMMARY": "Резюме",
      "NEW_MESSAGE": "Ново съобщение"
    },
    "PERIOD": {
      "SINGLE_DAY": "Един ден",
      "RANGE": "Период",
      "DATE": "Дата",
      "FROM": "От",
      "UNTIL_INCLUSIVE": "До включително",
      "ONE_PER_DAY_HINT": "В този проект може да е активна само една SWI на ден.",
      "TAKEN_DAYS_HINT": "Отбелязаните дни вече имат SWI и не могат да бъдат избрани.",
      "OVERLAP": "В този период вече има Start Werk Instructie. Избери други дати."
    },
    "CONTENT": {
      "MESSAGES_HEADING": "Съобщения",
      "MESSAGES_HINT": "Показват се само съобщения от тип Безопасност. Може да избереш няколко.",
      "MESSAGES_EMPTY": "Няма актуални съобщения за безопасност в този проект.",
      "INSTRUCTIONS_HEADING": "Инструкции",
      "INSTRUCTIONS_HINT": "Показва се само съдържание, отбелязано като използваемо в SWI.",
      "INSTRUCTIONS_EMPTY": "Няма инструкции, достъпни за SWI.",
      "TOOLBOXES_HEADING": "Toolbox-и",
      "TOOLBOXES_HINT": "Показва се само съдържание, отбелязано като използваемо в SWI.",
      "TOOLBOXES_EMPTY": "Няма toolbox-и, достъпни за SWI.",
      "CHECKLISTS_HEADING": "Контролни списъци",
      "CHECKLISTS_HINT": "Показва се само съдържание, отбелязано като използваемо в SWI.",
      "CHECKLISTS_EMPTY": "Няма контролни списъци, достъпни за SWI.",
      "MEDIUM_VIDEO": "Видео",
      "MEDIUM_DOCUMENT": "За четене"
    },
    "SUMMARY": {
      "CHANGE": "Промени",
      "NOTHING_SELECTED": "Нищо не е избрано",
      "NO_CONTENT": "Избери поне едно съобщение, инструкция, toolbox или контролен списък.",
      "SAVE": "Запази",
      "PERIOD_SINGLE": "Start Werk Instructie за {date}",
      "PERIOD_RANGE": "Start Werk Instructie от {from} до {to}"
    },
    "REPEAT": {
      "HEADING": "Повторение",
      "FIRST_ENTRY": "Само при първо влизане на обекта",
      "EVERY_ENTRY": "При всяко влизане на обекта",
      "AFTER_ABSENCE": "Да се проследи отново след отсъствие",
      "ABSENCE_DAYS": "По-дълго от (дни)",
      "ABSENCE_DAYS_RANGE": "Въведи число между {min} и {max}."
    },
    "EDIT_TITLE": "Редактиране на SWI",
    "NEW_MESSAGE": {
      "ACTION": "Ново съобщение (текст или видео)",
      "OR_PICK": "Или изберете съществуващи съобщения",
      "HINT": "Периодът и категорията се вземат от Start Werk Instructie.",
      "ADD": "Добавяне на съобщение",
      "SAVE": "Запазване на съобщението",
      "REMOVE": "Премахване на съобщението"
    },
    "FOLLOW": {
      "TITLE": "Start Werk Instructie",
      "INTRO": "Преминете през всичко по-долу и след това подпишете.",
      "PROGRESS": "{done} от {total} завършени",
      "EMPTY": "Днес няма нищо за преминаване по този проект.",
      "LOAD_FAILED": "Start Werk Instructie не можа да бъде заредена.",
      "RETRY": "Опитай отново",
      "NEXT": "Следваща стъпка",
      "SIGN_INTRO": "Проверете данните си и подпишете.",
      "NAME": "Име",
      "DATE": "Дата",
      "COMPANY": "Фирма",
      "FUNCTION": "Длъжност",
      "CLEAR": "Изчисти",
      "SIGN_AND_FINISH": "Подпиши и завърши",
      "SIGNED": "Start Werk Instructie е подписана",
      "SIGN_FAILED": "Подписването не бе успешно. Опитайте отново."
    },
    "CARD": {
      "HEADING": "Активна Start Werk Instructie",
      "STATUS_ACTIVE": "Активна",
      "STATUS_PLANNED": "Планирана",
      "PERIOD_RANGE": "{from} до {to}",
      "REPEAT_EVERY_ENTRY": "при всяко влизане на обекта",
      "REPEAT_FIRST_ENTRY": "само при първо влизане"
    }
  }
}
